import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=302e229c&scoped=true&"
var script = {}
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=302e229c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302e229c",
  null
  
)

export default component.exports